import { render, staticRenderFns } from "./SystemConfig.vue?vue&type=template&id=93a68204&scoped=true"
import script from "./SystemConfig.vue?vue&type=script&lang=js"
export * from "./SystemConfig.vue?vue&type=script&lang=js"
import style0 from "./SystemConfig.vue?vue&type=style&index=0&id=93a68204&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a68204",
  null
  
)

export default component.exports